import React, { useState, useEffect, useCallback, useRef } from "react";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import {
  Card,
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  InputAdornment,
  useMediaQuery,
} from "@mui/material";
import CustomAlert from "./CustomAlert";
import { connect } from "react-redux";
import { CustomButton } from "../components/CustomButton";
import { useParams } from "react-router-dom";
import { styles } from "../theme/styles";
import { styled } from "@mui/material/styles";
import { Creators as StoresCreators } from "../store/ducks/stores";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { verifyToken } from "../helpers/jwtValidation";
import { decodedData, encodeData } from "../helpers/encode";
import { parse } from "papaparse";
import TablePagination from "@mui/material/TablePagination";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Papa from "papaparse";
import DataTable from "./DataTable";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import axios from "axios";
import "../App.css";

const PedidoTiendaForm = (props) => {
  const apiPetcozoo_baseUrl = process.env.REACT_APP_API_PETCOZOO;
  const navigate = useNavigate();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [valorHora, setValorHora] = useState("");
  const [color, setColor] = useState("");
  const [mostrarSpiner2, setMostrarSpiner2] = useState(false);
  const [listaAuxiliarP, setListaAuxiliarP] = useState([]);
  const [auxDescarga, setAuxDescarga] = useState(false);
  const {
    token,
    storesInfo,
    storeId,
    downloadInventoryClusterByStore,
    loadingStores,
    signal,
    updateStoreById,
    getInventoryClusterByStore,
    inventoryCluster,
    getInfoStores,
    userData,
    updateInventoryOrder,
  } = props;
  const key = process.env.REACT_APP_PUBLICKEY;
  const [isUpTableButActive, setIsUpTableButActive] = useState(false);
  const [dataAux, setDataAux] = useState();
  const { idNumber } = useParams();
  const [initialRows, setInitialRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const inputFileRef = useRef(null);
  const [arrayInvalidoG, setArrayInvalidoG] = useState([]);
  const columnWidth = 100 / 8;
  const [inputValues, setInputValues] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [invalidRows, setInvalidRows] = useState([]);
  const [mostrarDataTable, setMostrarDataTable] = useState(false);
  const [arrayActual, setArrayActual] = useState([]);
  const [listaAuxiliar, setListaAuxiliar] = useState([]);
  const [actualizarInventoryCluster, setActualizarInventoryCluster] =
    useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [newPedidos, setNewPedidos] = useState(() => {
    const savedData = localStorage.getItem("nuevosPedidos");
    return savedData ? JSON.parse(savedData) : [];
  });
  const [rolEnCookie, setRolEnCookie] = useState();
  const [isButtonEnabledAux, setIsButtonEnabledAux] = useState();
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [variableSegundos, setVariableSegundos] = useState(10);
  const [iniciarContador, setIniciarContador] = useState(false);
  const [mostrarContador, setMostrarContador] = useState(false);
  const [iniciarProceso, setIniciarProceso] = useState(false);

  const handleCloseDialog2 = () => {
    setOpenDialog2(false);
  };

  function ordenarPorStockProvider(inventoryCluster) {
    if (inventoryCluster != undefined) {
      return inventoryCluster.sort((a, b) => b.stockProvider - a.stockProvider);
    } else {
      return [];
    }
  }
  useEffect(() => {
    if (props) {
    }
  }, [props]);
  useEffect(() => {
    setTableData(inventoryCluster);
  }, [inventoryCluster]);

  useEffect(() => {
    if (Cookies.get("loginCookie")) {
      const horaAux2 = obtenerHoraActual();
      const loginCookie = Cookies.get("loginCookie");
      const userData = verifyToken(loginCookie).data.data;
      // console.log("cookievalor: ", userData);
      //cookie para hora
      if (!Cookies.get("hora")) {
        encodeData("horaAux", "true");
      }
      encodeData("hora", horaAux2);
      setRolEnCookie(userData);
      if (userData.rol == "STORE") {
        //const isMonday = new Date().getDay() === 1;//ORIGINAL, DEVOLVER A ESTE
        const isMonday = new Date().getDay() === 2;
        const currentHour = new Date().getHours();
        //const isInTimeRange = currentHour >= 10 && currentHour < 18; //ORIGINAL, DEVOLVER A ORIGINAL
        const isInTimeRange = currentHour >= 8 && currentHour < 18;
        const isButtonEnabled = isMonday && isInTimeRange;
        // console.log("valor de es martes y en horario:", isButtonEnabled);
        setIsButtonEnabledAux(isButtonEnabled);
      } else if (userData.rol == "ADMIN") {
        const currentDate = new Date();
        const currentDay = currentDate.getDay();
        const currentHour = currentDate.getHours();
        const isInTimeRange =
          (currentDay === 1 && currentHour >= 8) ||
          currentDay === 2 ||
          (currentDay === 1 && currentHour >= 8) ||
          currentDay === 2 ||
          currentDay === 3 ||
          (currentDay === 4 && currentHour < 24);
        // console.log(
        //   "valor de en el rango martes 8 AM hasta jueves 11:59:59:",
        //   isInTimeRange
        // );
        setIsButtonEnabledAux(isInTimeRange);
      }
    }
  }, []);

  function encryptAndStoreArray(array, key) {
    // Convierte el array a una cadena JSON
    const stringifiedArray = JSON.stringify(array);
    // Cifra la cadena utilizando una clave secreta (key)
    const encryptedData = CryptoJS.AES.encrypt(
      stringifiedArray,
      key,
    ).toString();

    // Almacena los datos cifrados en localStorage
    localStorage.setItem("encryptedArray", encryptedData); //aqui
    // Cookies.set("encryptedArray", encryptedData);
  }

  function decryptAndRetrieveArray(key) {
    const encryptedData = localStorage.getItem("encryptedArray");
    if (encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, key);
      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedString);
    } else {
      return null;
    }
  }

  const getPedidos = async () => {
    if (token) {
      const horaAux = await obtenerHoraActual();
      setValorHora(horaAux);
      setColor("");
      await getInventoryClusterByStore(token, idNumber || storeId);
    }
  };

  useEffect(() => {
    if (token) {
      getPedidos();
    }
  }, [token, getInventoryClusterByStore]);

  const validarColores = async () => {
    if (Cookies.get("horaAux")) {
      setTimeout(() => {
        setColor("orange");
      }, 60000);
      setTimeout(() => {
        setColor("red");
        setIniciarContador(true);
        setMostrarContador(true);
      }, 120000);
    } else {
      setTimeout(() => {
        setColor("orange");
      }, 60000);
      setTimeout(() => {
        setColor("red");
      }, 120000);
    }
  };

  useEffect(() => {}, [newPedidos, decodedData("datosInvalidoss")]); // Dependencia de useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsUpTableButActive(true);
      setIniciarProceso(true);
      validarColores();
      // setMostrarContador(true);
      // }, 4000);
    }, 120000);
    return () => clearTimeout(timer);
  }, []);

  /*useEffect(() => {
    if (!isUpTableButActive && token) {
      const interval = setInterval(() => {
        getPedidos();
      }, 20000);
      return () => clearInterval(interval);
    }
  }, [isUpTableButActive, token]);*/

  function filtrarPorIdProviderYMaterial(array, idProvider, material) {
    return array.find(
      (obj) => obj.idProvider === idProvider && obj.material === material,
    );
  }
  const handleInputChange = (index, value) => {
    if (value !== "" && !/^\d+$/.test(value)) {
      setAlertMessage(
        "El valor debe ser un número entero mayor o igual que cero y sin espacios.",
      );
      setAlertOpen(true);
      return;
    }
    if (/\s/.test(value)) {
      setAlertMessage("El valor no debe contener espacios en blanco.");
      setAlertOpen(true);
      return;
    }
    if (value === "0") {
      setAlertMessage("¿Estás seguro de que deseas ingresar 0?");
      setAlertOpen(true);
    }
    const newValues = [...inputValues];
    newValues[index] = value;
    setInputValues(newValues);
  };
  const handleCloseAlert = () => {
    setAlertOpen(false);
  };
  function esperar3Segundos() {
    setTimeout(function () {}, 3000);
  }
  const updateInventoryOrder2 = async (token, storeId, updates) => {
    try {
      const result = await axios.put(
        `${apiPetcozoo_baseUrl}/stores/updateInventoryOrder/${storeId}`,
        updates,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        },
      );
      if (result.data.messageUpdates.length > 0) {
        const errorPedido =
          JSON.parse(localStorage.getItem("errorPedido")) || [];
        const updatedErrorPedido = [
          ...errorPedido,
          ...result.data.messageUpdates,
        ];
        encodeData("errorPedido", `${JSON.stringify(updatedErrorPedido)}`);
        // localStorage.setItem("errorPedido", JSON.stringify(updatedErrorPedido));
      }
      return;
    } catch (error) {
      console.error("Error actualizando Order:", error);
    }
  };

  const handlePrintValues = async () => {
    var arrayAux = [];
    const updates = await Promise.all(
      rowsToDisplay.map(async (row, rowIndex) => {
        const inputValue = inputValues[rowIndex];
        if (inputValue && inputValue.trim() !== "") {
          try {
            const stockReal = await axios.get(
              `${apiPetcozoo_baseUrl}/stores/getProveedorStock/${row.idProvider}/${row.material}`,
              {
                providerId: row.idProvider,
                material: row.material,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  authorization: token,
                },
              },
            );
            return {
              material: row.material,
              providerId: parseInt(row.idProvider, 10),
              priceProvider: row.price,
              stockProvider: stockReal.data.stock,
              newOrder: parseInt(inputValue, 10),
            };
          } catch (error) {
            console.error("Error al obtener stockReal:", error);
          }
        }
        return; // Si no se cumple la condición, devuelve null
      }),
    );
    const filteredUpdates = updates.filter((item) => item);
    const tiendaSelected = storesInfo.idNumber;
    if (updates.length == 0) {
      Swal.fire({
        icon: "info",
        title: "Realice alguna orden.",
        iconColor: "#00205B",
        showConfirmButton: true,
        confirmButtonColor: "#00205B",
      });
    } else {
      try {
        setMostrarSpiner2(true);
        const auxInfo2 = await updateInventoryOrder2(
          token,
          idNumber ?? storeId,
          { updates: filteredUpdates },
        );
        const rowsWithOrders = await rowsToDisplay.filter((row, rowIndex) => {
          const inputValue = inputValues[rowIndex];
          return inputValue && inputValue.trim() !== "";
        });
        setFilteredRows((prevRows) => {
          const updatedRows = [...prevRows];
          rowsWithOrders.forEach((row, index) => {
            updatedRows[startIndex + index] = row;
          });
          return updatedRows;
        });
        setInputValues([]);
        const errorPedido =
          JSON.parse(localStorage.getItem("errorPedido")) || [];
        const materiales = errorPedido.map((item) => item.material).join(", ");
        if (errorPedido.length == 0) {
          await Swal.fire({
            icon: "success",
            title: "Éxito",
            text: "La operación se completó exitosamente.",
            showConfirmButton: true,
            confirmButtonColor: "#00205B",
          });
          if (token) {
            getPedidos();
          }
          setMostrarSpiner2(false);
          localStorage.clear();
        } else {
          await Swal.fire({
            icon: "warning",
            title: "Alerta",
            text: `Se produjo un error al enviar las siguientes ordenes ${materiales}, por favor valida los datos ingresados.`,
            showConfirmButton: true,
            confirmButtonColor: "#00205B",
          });
          if (token) {
            getPedidos();
          }
          localStorage.clear();
        }
        setMostrarSpiner2(false);
      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: "Se produjo un error al realizar la operación.",
          showConfirmButton: true,
          confirmButtonColor: "#00205B",
        });
        localStorage.clear();
        setMostrarSpiner2(false);
      }
    }
  };

  useEffect(() => {
    if (token) {
      if (idNumber) {
        getInfoStores(token, idNumber);
      } else {
        getInfoStores(token, storeId);
      }
    }
  }, [token, idNumber, storeId, getInfoStores]);

  useEffect(() => {
    setInitialRows(inventoryCluster ?? []);
    setFilteredRows(inventoryCluster ?? []);
    setLoading(inventoryCluster ? true : false);
    setLoading2(inventoryCluster ? true : false);
    //console.log("inventoryCluster", inventoryCluster);
    setArrayActual(inventoryCluster);
    // encodeData("inventoryCluster", `${JSON.stringify(inventoryCluster)}`);
    encryptAndStoreArray(inventoryCluster, key);
    // localStorage.setItem("inventoryCluster", JSON.stringify(inventoryCluster));
  }, [inventoryCluster, actualizarInventoryCluster]);

  useEffect(() => {
    const filtered =
      initialRows &&
      initialRows.filter((row) => {
        const {
          nameProvider,
          subCategoryName,
          description,
          subCategory,
          material,
          stock,
          priceProvider,
        } = row;
        const searchValue = searchTerm.toLowerCase();
        return (
          String(nameProvider.toLowerCase()).includes(searchValue) ||
          String(subCategoryName.toLowerCase()).includes(searchValue) ||
          String(description.toLowerCase()).includes(searchValue) ||
          String(subCategory).includes(searchValue) ||
          String(material).includes(searchValue) ||
          String(stock).includes(searchValue) ||
          String(priceProvider).includes(searchValue)
        );
      });
    setFilteredRows(filtered);
    if (searchTerm.length > 0) {
      setPage(0);
    }
  }, [searchTerm, filteredRows]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#00205b",
      color: theme.palette.common.white,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#dcffed",
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const handleSearch = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  const blockEditByRol = (isAdminUser) => {
    const currentDate = new Date();
    const currentDay = currentDate.getDay();
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();

    if (
      (isAdminUser && (currentDay === 2 || currentDay === 3)) ||
      (!isAdminUser &&
        currentDay === 3 &&
        currentHour <= 23 &&
        currentMinute <= 59)
    ) {
      return false;
    } else {
      return true;
    }
  };
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleStores = async (event) => {
    downloadInventoryClusterByStore(token, idNumber || storeId);
  };

  async function handleStores2() {
    try {
      const urlDownload = `${apiPetcozoo_baseUrl}/stores/downloadInventoryClusterByStore/${
        idNumber || storeId
      }`;
      const downloadResponse = await axios({
        method: "get",
        url: urlDownload,
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
        responseType: "blob",
      });
      const blob = new Blob([downloadResponse.data], { type: "text/csv" });
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const formattedDate = `${day}-${month}-${year}`;
      const fileName = `InventarioCluster_${
        idNumber || storeId
      }_${formattedDate}.csv`;
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.setAttribute("download", fileName);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: "Ocurrió un error al descargar el archivo.",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#00205B",
      });
      setAuxDescarga(false);
    }
  }

  const validarNombrerchivoCSV = (nombre) => {
    if (nombre.toLowerCase().startsWith("inventariocluster")) {
      return "es valido";
    } else {
      Swal.fire({
        title: "No es un archivo valido",
        text: "Verifica el nombre del archivo",
        icon: "warning",
        confirmButtonColor: "#00205B",
      });
      return "no es valido";
    }
  };
  function obtenerHoraActual() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Los meses empiezan desde 0
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  }
  const validarTienda = (nombre) => {
    let patronEXD = /_(\d+)_/;
    let resultado = nombre.match(patronEXD);
    if (resultado && resultado.length > 1) {
      return resultado[1];
    } else {
      return null;
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const nombreExcel = validarNombrerchivoCSV(file.name);
    if (nombreExcel == "no es valido") {
      return;
    } else {
      const tiendaExcelV = validarTienda(file.name);
      if (tiendaExcelV.toString() !== storesInfo.idNumber.toString()) {
        Swal.fire({
          title: "Tienda Erronea",
          text: "Verifica el número de tienda del archivo",
          icon: "warning",
          confirmButtonColor: "#00205B",
        });
        return;
      }
    }
    if (!file) {
      return;
    }
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: function (result) {
        const datosExcel = result.data;
        let arrayValido = [];
        let arrayInvalido = [];
        let arrayInvalido2 = [];
        const inventoryClusterDecoded = decryptAndRetrieveArray(key) || [];
        datosExcel.forEach((item) => {
          const matchingItem = inventoryCluster.find(
            (invItem) =>
              parseInt(invItem.idProvider) === parseInt(item["No Proveedor"]) &&
              invItem.material.toString() === item["Material"].toString(),
          );
          if (matchingItem) {
            item["precio proveedor"] = matchingItem.price;
            item["Existencia Proveedor"] = matchingItem.stockProvider;
            const pruebaMary2 = matchingItem.order;
            const operacionStock = pruebaMary2 - parseInt(item["Orden"]);
            const newStockProvider =
              matchingItem.stockProvider + operacionStock;
            if (matchingItem.stockProvider > 0 && item["Orden"] > 0) {
              if (newStockProvider >= 0) {
                if (isAdminUser) {
                  if (item.Subcategoria !== null) {
                    arrayValido.push(item);
                  } else {
                  }
                } else {
                  if (item.Subcategoria !== null) {
                    arrayValido.push(item);
                  } else {
                  }
                }
              } else if (item["Orden"] > matchingItem.stockProvider) {
                arrayInvalido2.push(item);
              }
            } else {
              // console.log("matchingItem?=?",matchingItem)
              // Si el stockProvider es 0 (o la Orden no es mayor que 0, lo cual parece no manejarse correctamente en tu lógica original)
              //console.log("iteminvalido1", item);
              // arrayInvalido2.push(item);
            }
            setArrayInvalidoG(arrayInvalido2);
          } else {
            arrayInvalido.push(item);
            //console.log("itemInfoInvalido2", item);
          }
        });
        function separarRegistrosPorExistencia(array) {
          const sinExistencia = array.filter(
            (item) => item["Existencia Proveedor"] === 0,
          );
          const conExistencia = array.filter(
            (item) => item["Existencia Proveedor"] > 0,
          );
          return {
            sinExistencia,
            conExistencia,
          };
        }
        const resultado = separarRegistrosPorExistencia(arrayInvalido2);
        encodeData(
          "datosInvalidoss",
          `${JSON.stringify(resultado.conExistencia)}`,
        );
        // localStorage.setItem(
        //   "datosInvalidoss",
        //   JSON.stringify(resultado.conExistencia)
        // );
        const realizarPedidos = async () => {
          const inventoryCluster = decryptAndRetrieveArray(key) || [];
          const updatesArray = [];
          for (let i = 0; i < arrayValido.length; i++) {
            try {
              const token2 = token;
              const config = {
                headers: {
                  Accept: "application/json, text/plain, */*",
                  authorization: token2,
                },
              };
              const matchingItem = inventoryCluster.find(
                (item) =>
                  parseInt(item.idProvider) ===
                    parseInt(arrayValido[i]["No Proveedor"]) &&
                  item.material.toString() ===
                    arrayValido[i]["Material"].toString(),
              );
              const priceProvider = matchingItem
                ? matchingItem.price
                : arrayValido[i]["Precio Proveedor"].toString();
              const stockProvider = matchingItem
                ? matchingItem.stockProvider
                : parseInt(arrayValido[i]["Existencia Proveedor"]);
              updatesArray.push({
                material: arrayValido[i]["Material"].toString(),
                providerId: parseInt(arrayValido[i]["No Proveedor"]),
                priceProvider: priceProvider,
                stockProvider: stockProvider,
                newOrder: parseInt(arrayValido[i]["Orden"]),
              });
            } catch (error) {}
          }
          const data = {
            updates: updatesArray,
          };
          const pedidoEnviado = await updateInventoryOrder(
            token,
            idNumber ?? storeId,
            data,
          );
          // console.log("pedidoEnviado: ", pedidoEnviado);
        };
        realizarPedidos();
        if (token) {
          getPedidos();
        }
        const textoParaSwal = arrayValido.map(
          (item) => `${item.Descripcion} \n`,
        );
        const textoParaSwalHTML = `<div style="max-height: 175px; overflow-y: auto; width: 100%;">
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="text-align: center; border-bottom: 1px solid #ddd;">Material</th>
              <th style="text-align: center; border-bottom: 1px solid #ddd; width:70px">Orden</th>
            </tr>
          </thead>
          <tbody>${arrayValido
            .map(
              (item) =>
                `<tr><td style="border-bottom: 1px solid #ddd;">${item.Descripcion}</td><td style="border-bottom: 1px solid #ddd;">${item.Orden}</td></tr>`,
            )
            .join("")}
          </tbody>
        </table>
      </div>`;
        const textoParaSwalHTML2 = `<ul style="max-height: 175px; overflow-y: scroll; list-style-type: none; padding: 0;">${arrayValido
          .map((item) => `<li>Sin Items enviados</li>`)
          .join("")}</ul>`;
        Swal.fire({
          title:
            arrayValido.length > 0
              ? "Se enviaron las siguientes órdenes"
              : "No se envió ninguna orden",
          html:
            arrayValido.length > 0
              ? textoParaSwalHTML
              : "Favor de verificarlas",
          icon: arrayValido.length > 0 ? "success" : "warning",
          confirmButtonColor: "#00205B",
          iconColor: arrayValido.length > 0 ? "green" : "red",
          customClass: {
            container: "my-swal-zindex",
          },
        });
        if (arrayInvalido2.length > 0) {
          setMostrarDataTable(true);
        } else {
          setMostrarDataTable(false);
        }
        event.target.value = "";
      },
      error: function (error) {
        console.error("Error al convertir el archivo csv===", error);
      },
    });
  };
  const updateMyData = (rowIndex, columnId, value) => {
    const datosInvalidos = JSON.parse(decodedData("datosInvalidoss"));
    console.log("datosInvalidosss", datosInvalidos);
    const newData = datosInvalidos.map((row, index) => {
      if (index === rowIndex) {
        const matchingItem = inventoryCluster.find(
          (invItem) =>
            parseInt(invItem.idProvider) === parseInt(row["No Proveedor"]) &&
            invItem.material.toString() === row["Material"].toString(),
        );
        if (matchingItem) {
          const stockOreded = matchingItem.order;
          const operacionStock = stockOreded - value;
          const newStockProvider = matchingItem.stockProvider + operacionStock;
          /*console.log("ORDERED MARY", stockOreded); //ya ordenado
          console.log("NEW ORDER MARY", value); //new ordered
          console.log("OPERACION MARY", operacionStock); //operacion
          console.log("STOCK MARY", matchingItem.stockProvider);
          console.log("NEW STOCK MARY", newStockProvider);*/

          return {
            ...row,
            [columnId]: newStockProvider >= 0 ? value : 0,
          };
        }
      }
      return row;
    });
    encodeData("datosInvalidoss", `${JSON.stringify(newData)}`);
    setNewPedidos(newData);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const workWithNewPedidos = (e) => {
    console.log("1");
    console.log("nuevos Pedidos", e.target.value);
  };

  const reenviarPedidos = async (e) => {
    e.preventDefault();
    // let ls = JSON.parse(localStorage.getItem("datosInvalidoss"));
    let ls = JSON.parse(decodedData("datosInvalidoss"));
    console.log("arrayparaReenviar====?", ls);
    console.log("inventory cluster: ", inventoryCluster);
    //validacion órdenes validas
    function validarItems(datosExcel, inventoryCluster) {
      const arrayValido2 = [];
      const arrayInvalido2 = [];
      const arrayInvalido = [];
      console.log("datosExcel: ", datosExcel);
      datosExcel.forEach((item) => {
        // Buscar el elemento en 'inventoryCluster' que coincida con el 'idProvider' y 'material'
        const matchingItem = inventoryCluster.find(
          (invItem) =>
            parseInt(invItem.idProvider) === parseInt(item["No Proveedor"]) &&
            invItem.material.toString() === item["Material"].toString(),
        );
        console.log("MATCHING ITEM MARY", matchingItem);
        // Verificar si existe el item en 'inventoryCluster'
        if (matchingItem) {
          // Asignar 'precio proveedor' y 'Existencia Proveedor' desde matchingItem
          item["precio proveedor"] = matchingItem.price;
          item["Existencia Proveedor"] = matchingItem.stockProvider;
          const pruebaMary2 = matchingItem.order;
          const operacionStock = pruebaMary2 - parseInt(item["Orden"]);
          const newStockProvider = matchingItem.stockProvider + operacionStock;
          if (matchingItem.stockProvider > 0 && item["Orden"] > 0) {
            if (newStockProvider >= 0) {
              if (isAdminUser == true) {
                console.log("1");
                if (item.Subcategoria != "") {
                  arrayValido2.push(item);
                }
              } else if (isAdminUser == false) {
                console.log("2");
                if (item.Subcategoria != "") {
                  arrayValido2.push(item);
                }
              } else {
                alert("item invalido", item);
              }
            } else if (item["Orden"] > matchingItem.stockProvider) {
              arrayInvalido2.push(item);
            }
          } else {
            arrayInvalido2.push(item);
          }
        } else {
          arrayInvalido.push(item);
        }
      });

      return { arrayValido2, arrayInvalido2, arrayInvalido };
    }
    var resultado2 = validarItems(ls, inventoryCluster);
    console.log("ReenviarPedidosINVALIDO: ", resultado2.arrayInvalido2);
    console.log("ReenviarPedidosVALIDO: ", resultado2.arrayValido2);
    console.log("ReenviarPedidosNOVALIDOS: ", resultado2.arrayInvalido);
    //envio de órdenes validas
    const realizarPedidos = async () => {
      const inventariocluster = decryptAndRetrieveArray(key) || [];
      for (let i = 0; i < resultado2.arrayValido2.length; i++) {
        try {
          const token2 = token;
          const config = {
            headers: {
              Accept: "application/json, text/plain, */*",
              authorization: token2, // Aquí se usa el token directamente sin 'Bearer'
            },
          };
          // Buscar el elemento en 'inventoryCluster' que coincida con el 'providerId' y 'material' actuales de 'resultado2.arrayValido2'
          const matchingItem = inventoryCluster.find(
            (item) =>
              parseInt(item.idProvider) ===
                parseInt(resultado2.arrayValido2[i]["No Proveedor"]) &&
              item.material.toString() ===
                resultado2.arrayValido2[i]["Material"].toString(),
          );
          // console.log("matchingItem===",matchingItem)
          // Usar el 'price' de 'inventoryCluster' si se encuentra una coincidencia
          const priceProvider = matchingItem
            ? matchingItem.price
            : resultado2.arrayValido2[i]["Precio Proveedor"].toString();
          const stockProvider = matchingItem
            ? matchingItem.stockProvider
            : parseInt(resultado2.arrayValido2[i]["Existencia Proveedor"]);
          // console.log("priceProviderEncontrado===",priceProvider)
          // console.log("stockProviderEncontrado===",stockProvider)
          const data = {
            updates: [
              {
                material: resultado2.arrayValido2[i]["Material"].toString(),
                providerId: parseInt(
                  resultado2.arrayValido2[i]["No Proveedor"],
                ),
                priceProvider: priceProvider,
                stockProvider: stockProvider,
                newOrder: parseInt(resultado2.arrayValido2[i]["Orden"]),
              },
            ],
          };
          //console.log("REENVIANDOS a updateInventoryOrder: ", data);
          const pedidoEnviado = await updateInventoryOrder(
            token,
            idNumber ?? storeId,
            data,
          );
          eliminarObjetoDeDatosInvalidos(resultado2.arrayValido2[i]);
        } catch (error) {
          console.log("error al enviar datos del excel", error);
        }
      }
    };
    function eliminarObjetoDeDatosInvalidos(objetoAEliminar) {
      const datosInvalidos = JSON.parse(decodedData("datosInvalidoss"));
      const indice = datosInvalidos.findIndex(
        (item) =>
          item["No Proveedor"] === objetoAEliminar["No Proveedor"] &&
          item["Material"] === objetoAEliminar["Material"],
      );
      if (indice !== -1) {
        datosInvalidos.splice(indice, 1);
      } else {
      }
    }
    console.log("valorantesdereenvio: ", resultado2.arrayValido2);
    if (resultado2.arrayValido2.length > 0) {
      realizarPedidos(resultado2.arrayValido2);
      const textoParaSwal = resultado2.arrayValido2.map(
        (item) => `${item.Descripcion} \n`,
      );
      Swal.fire({
        title: "Se enviaron las siguientes órdenes",
        text: textoParaSwal,
        icon: "success",
        confirmButtonColor: "#00205B",
        customClass: {
          container: "my-swal-zindex",
        },
      });
    }
    if (resultado2.arrayInvalido2.length > 0) {
    } else {
      setMostrarDataTable(false);
      e.target.value = "";
    }
  };

  const FinalizarPedidos = (e) => {
    e.preventDefault();
    setMostrarDataTable(false);
    e.target.value = "";
  };
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  function filtrarProductos(productos) {
    return productos.filter((producto) => producto.stockProvider > 0);
  }
  const aux = filtrarProductos(filteredRows);
  // setDataAux(aux)
  const rowsToDisplay = aux.slice(startIndex, endIndex);
  // const rowsToDisplay = filteredRows.slice(startIndex, endIndex);

  const isAdminUser = userData.rol === "ADMIN";
  return (
    <div style={{ height: "100%", width: "90%" }}>
      <div className="pedidoTiendaDiv">
        {storesInfo && (
          <div style={styles.infoTiendaPZ}>
            <div height="50%">
              <p className="nameTienda">TIENDA {storesInfo.storeName}</p>
              <p className="nameCluster">
                No. {idNumber ? idNumber : storeId} Clúster:{" "}
                {storesInfo.cluster}
              </p>
            </div>

            <div height="50%">
              <div className="iconsTienda2">
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description">
                  <DialogTitle style={styles.dialoginf} id="alert-dialog-title">
                    {isAdminUser ? (
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon icon-tabler icon-tabler-alert-circle-filled"
                          width="64"
                          height="64"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="#ff2825"
                          fill="#00205b"
                          stroke-linecap="round"
                          stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path
                            d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z"
                            stroke-width="0"
                            fill="#00205b"
                          />
                        </svg>
                        <br />
                        <span>
                          Recuerda que solo puedes cargar tu inventario desde el
                          martes a las 8:00 a.m. hasta el jueves a las 11:59
                          p.m.
                        </span>
                      </div>
                    ) : (
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon icon-tabler icon-tabler-alert-circle-filled"
                          width="64"
                          height="64"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="#ff2825"
                          fill="#00205b"
                          stroke-linecap="round"
                          stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path
                            d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z"
                            stroke-width="0"
                            fill="#00205b"
                          />
                        </svg>
                        <br />
                        <span>
                          No olvides que solo puedes cargar tu inventario los
                          días lunes de las 10:00:00 a las 18:00:00 hrs.
                        </span>
                      </div>
                    )}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText
                      style={styles.dialoginf}
                      id="alert-dialog-description">
                      De lo contrario la carga del pedido no estará disponible.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Ok</Button>
                  </DialogActions>
                </Dialog>
                <IconButton onClick={handleClickOpen} sx={{ padding: 0.4 }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-info-circle"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="#00205b"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                    <path d="M12 9h.01" />
                    <path d="M11 12h1v4h1" />
                  </svg>
                </IconButton>
                <Button
                  style={{ fontSize: "12px" }}
                  variant="outlined"
                  color="primary"
                  size="small"
                  startIcon={<FileDownloadIcon />}
                  // onClick={handleStores}
                  onClick={async (e) => {
                    e.preventDefault();
                    setAuxDescarga(true);
                    await handleStores2();
                    setAuxDescarga(false);
                  }}
                  // disabled={!isButtonEnabledAux || loadingStores} ////==>este
                  title="Descargar"
                  sx={{
                    "& .MuiButton-startIcon": {
                      marginRight: "4px",
                      marginLeft: "0px",
                    },
                  }}>
                  {!isSmallScreen && "Descargar"}
                </Button>
                <Button
                  size="small"
                  component="label"
                  variant="outlined"
                  title="Subir Archivo"
                  startIcon={<UploadFileIcon />}
                  // disabled={!isButtonEnabledAux || loadingStores} ////==>este
                  sx={{
                    "& .MuiButton-startIcon": {
                      marginRight: "4px",
                      marginLeft: "0px",
                    },
                  }}>
                  {!isSmallScreen && "Subir Archivo"}
                  <input
                    type="file"
                    accept=".csv"
                    ref={inputFileRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </Button>
                <Button
                  size="small"
                  component="label"
                  variant="outlined"
                  title="Ver Pedido"
                  onClick={() =>
                    navigate(`/verPedidoTienda/${storesInfo.idNumber}`)
                  }
                  startIcon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="icon icon-tabler icons-tabler-outline icon-tabler-clipboard-list">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                      <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                      <path d="M9 12l.01 0" />
                      <path d="M13 12l2 0" />
                      <path d="M9 16l.01 0" />
                      <path d="M13 16l2 0" />
                    </svg>
                  }
                  sx={{
                    "& .MuiButton-startIcon": {
                      marginRight: "4px",
                      marginLeft: "0px",
                    },
                  }}>
                  Ver Pedido
                </Button>
              </div>
              <div>
                <div className="pz-center">
                  <TextField
                    style={{ paddingTop: 8 }}
                    placeholder="Buscar"
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearch}
                    fullWidth
                    InputLabelProps={{
                      shrink: false,
                    }}
                    InputProps={{
                      style: {
                        padding: "4px",
                        height: "34px",
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-filter-search"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="gray"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M11.36 20.213l-2.36 .787v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414" />
                            <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                            <path d="M20.2 20.2l1.8 1.8" />
                          </svg>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {
                    //variable para que se muestre
                    mostrarDataTable &&
                      // localStorage.getItem("datosInvalidoss") && (
                      Cookies.get("datosInvalidoss") && (
                        <div>
                          <Dialog
                            sx={{
                              "& .MuiDialog-paper": { maxWidth: "none" },
                            }}
                            open={true}
                            onClose={handleCloseDialog2}>
                            <DialogTitle
                              style={{
                                textAlign: "center",

                                position: "relative",
                              }}>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  color: "red",
                                  margin: 0,
                                }}>
                                {/* Upps... Parece que tu orden tiene algunos inconvenientes. Por favor, revísala. */}
                                {/* Lo sentimos, tu orden contiene errores y no puede ser procesada tal como está. */}
                                ¡Atención! Tu orden no se ha podido procesar
                                correctamente debido a errores.
                              </p>
                              <p style={{ margin: 0 }}>
                                Por favor modifica las siguientes órdenes:
                              </p>
                              <Button
                                onClick={FinalizarPedidos}
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  top: 0,
                                  border: "solid red",
                                }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="icon icon-tabler icon-tabler-square-rounded-x"
                                  width="36"
                                  height="36"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="#00205b"
                                  fill="none"
                                  stroke-linecap="round"
                                  stroke-linejoin="round">
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M10 10l4 4m0 -4l-4 4" />
                                  <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
                                </svg>
                              </Button>
                            </DialogTitle>
                            <DialogContent>
                              <div className="tablaExcel">
                                <DataTable
                                  data={JSON.parse(
                                    decodedData("datosInvalidoss"),
                                  )}
                                  updateMyData={updateMyData}
                                  onChange={(e) => {
                                    e.preventDefault();
                                    console.log("evalue: ", e.target.value);
                                  }}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}>
                                  <CustomButton
                                    style={styles.Guardarbtn}
                                    onClick={reenviarPedidos}>
                                    Reenviar Pedido
                                  </CustomButton>
                                </div>
                              </div>
                            </DialogContent>
                          </Dialog>
                        </div>
                      )
                  }
                </div>
              </div>
            </div>
          </div>
        )}
        {auxDescarga && (
          <div
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.1)", // Fondo oscuro con opacidad
              zIndex: "9999", // Aseguramos que esté encima de todo
            }}>
            <ClipLoader color="#00205b" size={"60px"} />
          </div>
        )}

        <TableContainer
          sx={{
            "&::-webkit-scrollbar": {
              width: "8px",
              height: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#ABABAB",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#888",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
            },
            "& .MuiTableCell-root": {
              fontSize: {
                xs: "8px",
                sm: "12px",
                md: "13px",
              },
            },
          }}
          style={styles.containerC}>
          <Table stickyHeader>
            <thead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "#00205b",
                color: "white",
              }}>
              <tr>
                <th>PROVEEDOR</th>
                <th>MÍNIMO PARA PEDIDO</th>
                <th>TOTAL EN PEDIDO</th>
                <th>PORCENTAJE DE AVANCE</th>
              </tr>
            </thead>
            <tbody>
              {!loading2 && (
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      textAlign: "center",
                      verticalAlign: "middle",
                      height: "100px",
                      color: "#00205B",
                    }}>
                    <ClipLoader
                      color="#00205B"
                      className="custom-spinner"
                      loading={true}
                      size={40}
                    />
                  </td>
                </tr>
              )}
              {storesInfo &&
                storesInfo.providers &&
                (() => {
                  const rows = [];
                  const arrayProviders = [storesInfo.providers];
                  arrayProviders.forEach((provider) => {
                    Object.entries(provider).forEach(
                      ([providerNumber, minimum]) => {
                        if (
                          inventoryCluster &&
                          Array.isArray(inventoryCluster)
                        ) {
                          const matchingItem = inventoryCluster.find(
                            (item) => item.idProvider == providerNumber,
                          );
                          if (matchingItem && providerNumber !== "_id") {
                            const providerSignal = signal.find(
                              (signalItem) =>
                                signalItem.providerId === providerNumber,
                            );
                            if (providerSignal) {
                              const providerNameWords =
                                matchingItem.nameProvider.split(" ");
                              const shortProviderName = providerNameWords
                                .slice(0, 2)
                                .join(" ");
                              const percentage =
                                (providerSignal.totalOrderPrice / minimum) *
                                100;

                              let percentageDisplay;
                              let percentageStyle = {};

                              if (percentage >= 100) {
                                percentageDisplay = "COMPLETADO";
                                percentageStyle.backgroundColor = "#a3cd84";
                              } else {
                                percentageDisplay = `${percentage.toFixed(2)}%`;
                                if (percentage > 0 && percentage < 100) {
                                  percentageStyle.backgroundColor = "#f7e450";
                                } else if (percentage == 0) {
                                  percentageStyle.backgroundColor = "#efaa81";
                                }
                              }
                              rows.push({
                                providerNumber,
                                shortProviderName,
                                minimum,
                                totalOrderPrice: providerSignal.totalOrderPrice,
                                percentage,
                                percentageDisplay,
                                percentageStyle,
                              });
                            }
                          }
                        }
                      },
                    );
                  });
                  rows.sort((a, b) => b.percentage - a.percentage);

                  return rows.map(
                    ({
                      providerNumber,
                      shortProviderName,
                      minimum,
                      totalOrderPrice,
                      percentageDisplay,
                      percentageStyle,
                    }) => (
                      <tr key={providerNumber} className="border-pz">
                        <td>{shortProviderName}</td>
                        <td>${minimum}</td>
                        <td>${totalOrderPrice.toFixed(2)}</td>
                        <td style={percentageStyle}>{percentageDisplay}</td>
                      </tr>
                    ),
                  );
                })()}
            </tbody>
          </Table>
        </TableContainer>
      </div>

      <TableContainer
        sx={{
          "&::-webkit-scrollbar": {
            width: "8px",
            height: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ABABAB",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#888",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1",
          },
          "& .MuiTableCell-root": {
            fontSize: {
              xs: "8px",
              sm: "12px",
              md: "13px",
            },
          },
        }}
        style={styles.containerTablePedido}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">PROVEEDOR</StyledTableCell>
              <StyledTableCell align="center">MATERIAL</StyledTableCell>
              <StyledTableCell align="center">DESCRIPCIÓN</StyledTableCell>
              <StyledTableCell align="center">PRECIO</StyledTableCell>
              <StyledTableCell align="center">
                CANTIDAD PROVEEDOR
              </StyledTableCell>
              <StyledTableCell align="center">CANTIDAD TIENDA</StyledTableCell>
              <StyledTableCell align="center">CANTIDAD PEDIDO</StyledTableCell>
              <StyledTableCell align="center">EDITAR</StyledTableCell>
            </TableRow>
          </TableHead>

          {rowsToDisplay.length > 0 ? (
            <>
              <CustomAlert
                open={alertOpen}
                title={alertTitle}
                message={alertMessage}
                onClose={handleCloseAlert}
              />
              <TableBody>
                {!loading && (
                  <p style={{ marginTop: "80px" }}>
                    <ClipLoader
                      color="#00205B"
                      className="custom-spinner"
                      loading={true}
                      size={73}></ClipLoader>
                  </p>
                )}
                {rowsToDisplay &&
                  rowsToDisplay
                    .filter((row) => {
                      const searchValue = searchTerm.toLowerCase();
                      return (
                        // row.stockProvider >= 0 &&
                        // row.order > 0 &&
                        row.nameProvider.toLowerCase().includes(searchValue) ||
                        row.subCategoryName
                          .toLowerCase()
                          .includes(searchValue) ||
                        row.material.toString().includes(searchValue) ||
                        row.description.toLowerCase().includes(searchValue) ||
                        row.priceProvider.toString().includes(searchValue) ||
                        row.stockProvider.toString().includes(searchValue) ||
                        row.stock.toString().includes(searchValue) ||
                        row.order.toString().includes(searchValue)
                      );
                    })
                    .map((row, rowIndex) => (
                      <tr className="row-color-pz" key={`${rowIndex}`}>
                        <StyledTableCell align="center">
                          {row.nameProvider}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.material}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.description}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          ${parseFloat(row.priceProvider).toFixed(2)}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.stockProvider}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.stock}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.order}
                        </StyledTableCell>
                        <div align="center" style={styles.borderBottomTr}>
                          {row.stockProvider === 0 ? (
                            <p
                              style={{
                                margin: "10px",
                                fontSize: "13px",
                              }}>
                              No está disponible
                            </p>
                          ) : row.stockProvider >= 0 ? (
                            (isAdminUser &&
                              (row.subCategoryName === "AVES" ||
                                row.subCategoryName === "REPTILES" ||
                                row.subCategoryName === "MASCOTAS-REPTIL" ||
                                row.subCategoryName === "ROEDORES")) ||
                            (!isAdminUser &&
                              (row.subCategoryName === "ACUARIO-DECORACION" ||
                                row.subCategoryName === "PECES-AGUA DULCE" ||
                                row.subCategoryName === "REPTILES-ACCESORIOS" ||
                                row.subCategoryName ===
                                  "REPTILES-ALIMENTO")) ? (
                              <TextField
                                key={row.id}
                                id={`pedido-${row.id}`}
                                label="Pedido"
                                variant="outlined"
                                size="small"
                                value={inputValues[rowIndex] || ""}
                                // disabled={!isButtonEnabledAux || loadingStores} ////==>este
                                onChange={(e) =>
                                  handleInputChange(rowIndex, e.target.value)
                                }
                              />
                            ) : (
                              <TextField
                                key={row.id}
                                id={`pedido-${row.id}`}
                                label="Pedido"
                                variant="outlined"
                                size="small"
                                value={inputValues[rowIndex] || ""}
                                // disabled={!isButtonEnabledAux || loadingStores} ////==>este
                                onChange={(e) =>
                                  handleInputChange(rowIndex, e.target.value)
                                }
                              />
                            )
                          ) : null}
                        </div>
                      </tr>
                    ))}
              </TableBody>
            </>
          ) : (
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="center" colSpan="8">
                  <h1>NO HAY STOCK DISPONIBLE</h1>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <Card style={{ height: "8.5%" }}>
        <TablePagination
          sx={{
            display: "flex",
            justifyContent: "flex-start",
          }}
          component="div"
          count={aux != undefined ? aux.length : 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Productos por página:"
          rowsPerPageOptions={[20, 50, 100]}
        />
      </Card>
      {isUpTableButActive && (
        <div>
          Última actualización:
          <span
            style={{
              position: "relative",
              color: color,
              paddingLeft: "10px",
            }}>
            {valorHora}
          </span>
        </div>
      )}
      <div style={styles.GuardarP}>
        {isUpTableButActive && (
          <CustomButton
            style={styles.Guardarbtn}
            onClick={async (e) => {
              if (token) {
                getPedidos();
              }
            }}
            // disabled={!isButtonEnabledAux || loadingStores} ////==>este
          >
            Actualizar Tabla
          </CustomButton>
        )}

        {!mostrarSpiner2 ? (
          <CustomButton
            style={styles.Guardarbtn}
            onClick={handlePrintValues}
            // disabled={!isButtonEnabledAux || loadingStores} ////==>este
          >
            Guardar Pedido
          </CustomButton>
        ) : (
          <>
            <ClipLoader />
          </>
        )}
        {mostrarContador && Cookies.get("horaAux") && (
          <div style={{ position: "relative", right: 0 }}>
            <p>Actualizando información en {variableSegundos}...</p>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  // console.log("Redux State:", state);
  return {
    token: state.users.uid,
    userData: state.users.data,
    storeId: state.users.idNumber,
    inventoryCluster: state.stores.inventoryCluster,
    loadingInventoryCluster: state.stores.loadingInventoryCluster,
    storesInfo: state.stores.storesInfo,
    signal: state.stores.signal,
  };
};

const mapDispatchToProps = {
  updateStockStores: StoresCreators.updateStockStores,
  updateStoreById: StoresCreators.updateStoreById,
  getInventoryClusterByStore: StoresCreators.getInventoryClusterByStore,
  getInfoStores: StoresCreators.getInfoStores,
  downloadInventoryClusterByStore:
    StoresCreators.downloadInventoryClusterByStore,
  updateInventoryOrder: StoresCreators.updateInventoryOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(PedidoTiendaForm);
